import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DialogRef } from 'ngx-modialog';
import { ApiService } from '../../../../utils/services/api.service';

@Component({
  selector: 'app-room-modal',
  templateUrl: './room-modal.component.html',
  styleUrls: ['./room-modal.component.scss']
})
export class RoomModalComponent implements OnInit {
  public formGroup: FormGroup;
  public hotelId;
  public room;
  public status;

  constructor(public apiService: ApiService, public dialog: DialogRef<any>) {
    this.room = this.dialog.context.room;
    this.hotelId = this.dialog.context.hotelId;
    this.status = this.dialog.context.status;

  }


  ngOnInit() {
    this.formGroup = new FormGroup({
      'desc': new FormControl(null),
    });
  }
  closeModal() {
    this.dialog.close();
  }
  action(comment) {
    let data = {
      providerOrganizationId: this.hotelId,
      status: this.status,
      administrativeComment: comment.desc
    }
    this.apiService.roomUpdate(this.room.roomId, data).subscribe(res => {
      if (res.data) {
        this.closeModal()
        this.room.status = data.status
      }
    })
  }

}


// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/room-changes/room-modal/room-modal.component.ts